import { FeatureEnum } from './../core/properties/feature.enum';
import { FeatureToggleService } from './../core/services/feature-toggle.service';
import { Component, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { ProfileModelService, Role } from '../profile/profile-model.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  user: string;
  isAuthenticated = true;
  isLinearPlayoutToggleEnabled = false;
  isSubscriptionsToggleEnabled = false;
  newRelic = {
    label: 'Silence Detection Dashboard',
    icon: 'get_app',
    link: 'https://onenr.io/037jb23M3jy',
    queryParam: {},
    target: '_blank'
  };
  navLinks = [
    {
      label: 'Listen by Station',
      icon: 'mic',
      link: '/home',
      queryParam: {}
    },
    {
      label: 'Linear Playout',
      icon: 'mic',
      link: '/linear-playout',
      queryParam: {}
    },
    {
      label: 'Search',
      icon: 'keyboard',
      link: '/search',
      queryParam: {}
    },
    {
      label: 'Downloads',
      icon: 'get_app',
      link: '/downloads',
      queryParam: {}
    },
    {
      label: 'Subscriptions',
      icon: 'subscriptions',
      link: '/subscriptions',
      queryParam: {}
    }
  ];

  constructor(
    private authService: MsalService,
    private profileModelService: ProfileModelService,
    private featureToggleService: FeatureToggleService
  ) {}

  ngOnInit() {
    this.isLinearPlayoutToggleEnabled = this.featureToggleService.isEnabled(
      FeatureEnum.isLinearPlayoutToggleEnabled
    );
    this.isSubscriptionsToggleEnabled = this.featureToggleService.isEnabled(
      FeatureEnum.isSubscriptionsToggleEnabled
    );
    this.profileModelService.profileUpdated.subscribe((update) => {
      if (
        this.isAdminUser() &&
        update &&
        !this.navLinks.filter((link) => link.label === 'Manage').length
      ) {
        this.navLinks.unshift({
          label: 'Manage',
          icon: 'mic',
          link: '/manage',
          queryParam: {}
        });
      }
      if(!this.isLinearPlayoutToggleEnabled ) {
        this.navLinks = this.navLinks.filter((link) => link.label !== 'Linear Playout')
      }
      if(!this.isSubscriptionsToggleEnabled){
        this.navLinks = this.navLinks.filter((link) => link.label !== 'Subscriptions')
      }
      

    });
  }

  isAdminUser() {
    if (
      this.profileModelService.getProfile() &&
      this.profileModelService.getProfile().role &&
      this.profileModelService.getProfile().role.profileAccess
    ) {
      return (
        this.profileModelService.getProfile().role.profileAccess === Role.ADMIN
      );
    } else {
      return false;
    }
  }

  logout() {
    this.authService.logout();
  }

  userLogged() {
    return this.authService.instance?.getAllAccounts()[0] != null
      ? this.authService.instance.getAllAccounts()[0].name
      : '';
  }
}
